var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcceptIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.825,
    height: 12.41,
    viewBox: "0 0 17.825 12.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1711",
    "data-name": "Trac\\xE9 1711",
    d: "M81.532,88.913a1.688,1.688,0,0,1-1.211-.51l-4.7-4.814a1.693,1.693,0,1,1,2.422-2.365l3.548,3.634,8.531-7.905a1.692,1.692,0,1,1,2.3,2.482l-9.74,9.026A1.685,1.685,0,0,1,81.532,88.913Z",
    transform: "translate(-75.139 -76.503)",
    fill: "#3e3e3e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcceptIcon);
export default __webpack_public_path__ + "static/media/acceptIcon.0c07f6e7bfdb91a73d12b57b8fd9c422.svg";
export { ForwardRef as ReactComponent };